import { render, staticRenderFns } from "./PostPathway.vue?vue&type=template&id=1836e7d4&scoped=true&"
import script from "./PostPathway.vue?vue&type=script&lang=js&"
export * from "./PostPathway.vue?vue&type=script&lang=js&"
import style0 from "./PostPathway.vue?vue&type=style&index=0&id=1836e7d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1836e7d4",
  null
  
)

export default component.exports